import { ReactComponent as LayerIcon } from 'assets/icons/icon_layers.svg';
import TravelExploreRoundedIcon from '@mui/icons-material/TravelExploreRounded';

export const MY_MAP_WORKSPACE_TABS = [
    { 
        id: 'geocoder', 
        label: '주소 찾기', 
        // icon: TravelExploreRoundedIcon
        icon: (props) => <TravelExploreRoundedIcon {...props} fontSize="large" />, 
    },
    { id: 'user-data', label: '사용자 데이터', icon: LayerIcon },
];

export default MY_MAP_WORKSPACE_TABS;
